import * as types from './mutation-types'
export default {
  state: {
    topbarShow: false,
    footbarShow: false,
    conShow: false
  },
  mutations: {
    [types.SET_TOPBAR_SHOW] (state, topShow) {
      state.topbarShow = topShow
    },
    [types.SET_FOOTBAR_SHOW] (state, footbarShow) {
      state.footbarShow = footbarShow
    },
    [types.SET_CONNECT_SHOW] (state, conShow) {
      state.conShow = conShow
    }
  },
  actions: {
    setTopbar ({commit}, barshow) {
      commit(types.SET_TOPBAR_SHOW, barshow)
    },
    setFootbar ({commit}, footbarShow) {
      commit(types.SET_FOOTBAR_SHOW, footbarShow)
    },
    setConShow ({commit}, conShow) {
      commit(types.SET_CONNECT_SHOW, conShow)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/home/index.js